import { useState, useEffect } from "react";

const CUSTOMER_DETAILS_ENDPOINT = process.env.REACT_APP_GET_CUSTOMER_DETAILS;
const APIKEY = process.env.REACT_APP_APIKEY;

const useFetchCustomers = (messageFlowType = null, senderName = null) => {
  const [fetchCustomerData, setCustomerDetails] = useState(null);
  const [senderNames, setSenderNames] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSenderNames = async () => {
    try {
      const customer_url = `${CUSTOMER_DETAILS_ENDPOINT}?OutboundSenderList=Y`;

      const res = await fetch(customer_url, {
        headers: {
          "x-api-key": APIKEY,
        },
      });

      if (res.ok) {
        const data = await res.json();
        setSenderNames(data);
      } else {
        throw new Error("Could not fetch sender names");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerDetails = async (messageFlowType, senderName) => {
    try {
      setLoading(true);

      // Build query string based on parameters
      let queryString = "";
      if (messageFlowType) {
        queryString += `?MessageFlowType=${encodeURIComponent(messageFlowType)}`;
        if (senderName) {
          queryString += `&SenderName=${encodeURIComponent(senderName)}`;
        }
      }

      const customer_url = CUSTOMER_DETAILS_ENDPOINT + queryString;

      const res = await fetch(customer_url, {
        headers: {
          "x-api-key": APIKEY,
        },
      });

      if (res.ok) {
        const data = await res.json();
        setCustomerDetails(data);
      } else {
        throw new Error("Could not fetch customer data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch customer details only if messageFlowType is "Outbound" and senderName is not null or empty
    if ((messageFlowType === "Outbound" && senderName) || messageFlowType && messageFlowType !== "Outbound") {
      fetchCustomerDetails(messageFlowType, senderName);
    } else {
      setCustomerDetails(null); // Clear the data if no valid condition
    }

    // Fetch sender names once
    fetchSenderNames();
  }, [messageFlowType, senderName]);

  return { fetchCustomerData, senderNames, loading, error };
};

export default useFetchCustomers;
